module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r5r9r3n-4579461c7ffcbc4570596461070a5c29.svg";